import toast from 'react-hot-toast'

export default function TopQuestionsList({ questions, totalQuestions }) {
  if (!questions || questions.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6 h-full">
        <h3 className="text-sm font-semibold text-slate-900 mb-4">Top Questions</h3>
        <div className="flex items-center justify-center h-32 text-sm text-slate-400">
          No questions yet
        </div>
      </div>
    )
  }

  const copyQuestion = (q) => {
    navigator.clipboard.writeText(q)
    toast.success('Copied to clipboard')
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-slate-900">Top Questions</h3>
        <span className="text-xs text-slate-400">{totalQuestions} total</span>
      </div>
      <div className="space-y-2.5 max-h-64 overflow-y-auto">
        {questions.map((q, i) => (
          <div
            key={i}
            onClick={() => copyQuestion(q.question)}
            className="flex items-start space-x-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer transition-colors group"
          >
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center text-xs font-bold">
              {i + 1}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-slate-700 truncate">{q.question}</p>
              <p className="text-[10px] text-slate-400 mt-0.5">
                {q.count} times ({q.percentage}%)
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
